(() => {
  const buildYouTubeIframe = (player) => {
    const videoId = player.dataset.youtubeId;
    const videoTitle = player.dataset.videoTitle || 'Video';

    if (!videoId) return;

    const iframe = document.createElement('iframe');

    iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
    iframe.title = videoTitle;
    iframe.loading = 'lazy';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;

    player.innerHTML = '';
    player.appendChild(iframe);
    player.classList.add('video-recipe-article__player--loaded');
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-video-recipe-trigger]');
    if (!trigger) return;

    const player = trigger.closest('[data-video-recipe-player]');
    if (!player) return;

    buildYouTubeIframe(player);
  });
})();